import { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import AddAddressModal from 'profile/addressBook/AddModal';
import EditAddressModal from 'profile/addressBook/EditModal';
import {
  getClubMembership,
  editClubMembership
} from 'redux/clubMemberships/actions';

import AddressBook from './AddressBook';
import DisplayAddress from './DisplayAddress';
import PickupModal from './PickupModal';

class ShipTo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: null,
      editAddressId: null
    };
  }

  handleEditAddress = (id) => {
    this.setState({
      modal: 'editAddress',
      editAddressId: id
    });
  };

  handleAddAddress = () => {
    this.setState({
      modal: 'addAddress',
      editAddressId: null
    });
  };

  handlePickup = () => {
    this.setState({
      modal: 'pickup',
      editAddressId: null
    });
  };

  handleAddressSuccess = (address) => {
    const { props } = this;
    const clubMembershipId = props.clubMembership.id;
    const data = {
      orderDeliveryMethod: 'Ship',
      shipToCustomerAddressId: address.id
    };
    const successFunction = () => {
      this.handleCloseModal();
    };
    props.editClubMembership(clubMembershipId, data, successFunction);
  };

  handlePickupSuccess = (inventoryLocationId) => {
    const { props } = this;
    const clubMembershipId = props.clubMembership.id;
    const data = {
      orderDeliveryMethod: 'Pickup',
      pickupInventoryLocationId: inventoryLocationId
    };
    const successFunction = () => {
      this.handleCloseModal();
    };
    props.editClubMembership(clubMembershipId, data, successFunction);
  };

  handleAddressBook = () => {
    this.setState({
      modal: 'addressBook'
    });
  };

  handleCloseModal = () => {
    this.setState({
      modal: null,
      editAddressId: null
    });
  };

  render() {
    const { state } = this;
    const { clubMembership, customer, settings } = this.props;
    const object = {
      modal: state.modal,
      editAddressId: state.editAddressId,
      handleCloseModal: this.handleCloseModal,
      handleAddAddress: this.handleAddAddress,
      handlePickup: this.handlePickup,
      handleEditAddress: this.handleEditAddress,
      onHandleAddressSuccess: this.handleAddressSuccess,
      handleAddressBook: this.handleAddressBook,
      onHandlePickupSuccess: this.handlePickupSuccess,
      clubMembership
    };
    return (
      <>
        <DisplayAddress
          clubMembership={clubMembership}
          customer={customer}
          onEdit={this.handleAddressBook}
          settings={settings}
        />
        {renderModal(object)}
      </>
    );
  }
}

const renderModal = (object) => {
  const {
    modal,
    editAddressId,
    handleCloseModal,
    handleEditAddress,
    handleAddAddress,
    handlePickup,
    handleAddressBook,
    onHandlePickupSuccess,
    onHandleAddressSuccess,
    clubMembership
  } = object;
  switch (modal) {
    case 'editAddress': {
      return (
        <EditAddressModal
          onCloseModal={handleCloseModal}
          addressId={editAddressId}
          cancelFunction={handleAddressBook}
          onEditAddress={onHandleAddressSuccess}
        />
      );
    }
    case 'addAddress': {
      return (
        <AddAddressModal
          onCloseModal={handleCloseModal}
          cancelFunction={handleAddressBook}
          onAddAddress={onHandleAddressSuccess}
        />
      );
    }
    case 'pickup': {
      return (
        <PickupModal
          onCloseModal={handleCloseModal}
          cancelFunction={handleAddressBook}
          onHandlePickup={onHandlePickupSuccess}
          clubMembership={clubMembership}
        />
      );
    }
    case 'addressBook': {
      return (
        <AddressBook
          onCloseModal={handleCloseModal}
          handleEditAddress={handleEditAddress}
          handleAddAddress={handleAddAddress}
          handlePickup={handlePickup}
          onSelectAddress={onHandleAddressSuccess}
        />
      );
    }
    default: {
      return null;
    }
  }
};

const mapStateToProps = (state) => ({
  customer: state.customer,
  settings: state.setting
});

export default connect(mapStateToProps, {
  getClubMembership,
  editClubMembership
})(ShipTo);
